import React, { useEffect, useState } from 'react';
import getConfig from 'next/config';
import EirActionModal from '../eir-action-modal/EirActionModal';
import { setCookie } from '../../hooks/useCookie';
import fetchInfo from '../../../util/fetchModalData';

const NoEligibilityErrorModal = ({
  setEligibleForNone,
  eligibleForNone,
  setShowSubscriptionModal,
  setEnableModal,
  dualplaySubscriptions,
  defaultCSFlow,
}) => {
  const { publicRuntimeConfig } = getConfig();
  const handleClose = () => {
    setEligibleForNone(false);
    setEnableModal(false);
    if (dualplaySubscriptions?.length > 1) setShowSubscriptionModal(true);
    else {
      setCookie('CO', 'SUBSCRIPTION_ID', dualplaySubscriptions[0]?.id);
      defaultCSFlow();
    }
  };
  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const [load, setLoad] = useState(true);

  const getCmsData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: 'Error_Popup_No_Offer',
      });
      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsCollectionData(data);
      }
    } catch (error) {
      console.error('error', error);
    }
  };

  useEffect(() => {
    getCmsData();
  }, []);

  return (
    <EirActionModal
      open={eligibleForNone}
      id={cmsCollectionData?.attributes?.modalID}
      title={cmsCollectionData?.attributes?.title}
      iconSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsCollectionData?.attributes?.iconSrc?.data?.attributes?.url}`}
      description={`${
        cmsCollectionData?.attributes?.firstHalfDescription
          ? cmsCollectionData?.attributes?.firstHalfDescription
          : ''
      }
      ${
        cmsCollectionData?.attributes?.secondHalfDescription
          ? cmsCollectionData?.attributes?.secondHalfDescription
          : ''
      }
      `}
      cta={[
        {
          // text: 'ok',
          text: cmsCollectionData?.attributes?.cta[0]?.name
            ? cmsCollectionData?.attributes?.cta[0]?.name
            : 'ok',
          ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            : '',
          type: 'solid',
          action: () => handleClose(),
        },
      ]}
      disableCloseOnBackdropClick={false}
      disableCloseOnEscapeKeyDown={false}
      disablecta={false}
      load={load}
    />
  );
};
export default NoEligibilityErrorModal;
